import textStyles from '../TextMenu.module.css'
import exPAYMENT from "../../Img/Menu/Payment/exPaymentType.png";
import exRaifPay from "../../Img/Menu/Payment/raifPay.png";
import imSBP from '../../Img/Payment/sbp.svg'
import imMir from '../../Img/Payment/mir.svg'
import {useSelector} from "react-redux";
import {ReduxStateInt} from "../../Reducer/GlobalReducer";
import {Helmet} from "react-helmet";
import React from "react";


export default function MenuPayment(){
    const baseUrl = useSelector((state: ReduxStateInt) => {
        return state.baseUrl
    })
    return(
        <div className={textStyles.mainCont}>
            <Helmet>
                <title>sim-unlim : Оплата</title>
                <link rel="canonical" href="https://sim-unlim.com/payment" />
                <meta name="description" content="Оплата карты СБП штрихкод возврат" />
            </Helmet>
            <div className={textStyles.blCont}>
                <div className={textStyles.head}><p>Оплата заказа</p></div>
                <p>
                    <span className={textStyles.bold}>Варианты оплаты.</span> Расчет за товар можно осуществить несколькими способами :
                </p>
                <div className={textStyles.lsCont}>
                    <ul>
                        <li>
                            <div className={textStyles.plCont}>
                                <div>Система быстрых платежей (СБП)</div>
                            </div>
                        </li>
                        <li>
                            <div className={textStyles.plCont}>
                                <div>Банковская карта</div>
                            </div>

                        </li>
                    </ul>

                </div>
                <p className={textStyles.ident}>Выбор предлагается на этапе оплаты заказа</p>
                <div className={textStyles.cenCont}>
                    <div className={textStyles.imgCont}>
                        <img className={textStyles.widthImg} src={exPAYMENT}></img>
                        <div className={textStyles.imgTitle}>Рисунок 1. (Выбор способа оплаты)</div>
                    </div>
                </div>

                <p className={textStyles.ident}>
                    Все платежы происходят на стороне банка в защищенном фрейме. Мы не имеем доступа к Вашим платежным данным.
                    Платежи защищены по стандарту безопасности PCI DSS на стороне банка. Осуществляя оплату Вы принимаете  <a href={baseUrl + '/static/refund-politic.docx'}>политику возвратов.</a> Платежи проводятся через банк партнер Raiffeisenbank,
                    систему <img src={exRaifPay} className={textStyles.raifImg}/>
                </p>
                <div className={textStyles.cenCont}>
                    <p className={textStyles.bold}>
                        Платежи принимаются в сторону ИП Титов Д.Ю.
                    </p>
                    <p className={textStyles.bold}>
                        Реквизиты получателя
                    </p>
                </div>
                <div className={textStyles.reqCont}>
                    <div>ИП Титов Д.Ю.</div>
                    <div><span>ОГРНИП : </span>314547602100390</div>
                    <div><span>Офис : </span> г.Новосибирск, ул. Железнодорожная, д 15/1</div>
                    <div><span>Счет : </span>40802810107000689861</div>
                    <div><span>Банк : </span>Сибирский филиал АО "Райффайзенбанк"</div>
                    <div><span>БИК : </span>045004799</div>
                    <div><span>Корр.счет : </span>30101810300000000799</div>
                </div>
            </div>


            <div className={[textStyles.cenCont, textStyles.mt].join(' ')}>
                <div className={textStyles.head}><p >Гарантии на товар</p></div>
                <p>
                    <span className={textStyles.bold}>Гарантии возврата : </span>
                    В случае невозможности доставки товара, доставки некачественного или бракованного товара, продавец возвращает стоимость оплаченного заказа, включая стоимость доставки покупателю. Оформить заявку на возврат можно в личном кабинете. Максимальный срок возврата составляет 10 рабочих дней с момента оформления заявки на возврат. Возврат осуществляется исключительно на банковскую карту, с которой был осуществлен платеж. Денежные средства, внесенные на SIM-карту оператора, возврату не подлежат, т.к. эти денежные средства зачисляются в пользу оператора, а не продавца.
                </p>
            </div>
            <div className={textStyles.blCont}>
                <p>
                    <span className={textStyles.bold}>Гарантии на тариф : </span>
                    Операторы мобильной связи имеют право в одностороннем порядке пересмотра цен на услуги связи не чаще, чем один раз в год. В случае изменения тарифного плана, оператор заблаговременно уведомляет клиента об изменении цен. По вопросам изменения тарифного палана клиенту следует обратиться к оператору связи или к персональному менеджеру нашей компании через личный кабинет.
                </p>
            </div>


        </div>

    )
}